import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import Navbar from "../components/Navbar";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

// Reconstituie raportul din scores_json și declanșează print PDF
function downloadReportPDF(r) {
  const s = r.scores || {};
  const verdicts = {
    publish_now:    { label: "Publish Now",    color: "#059669", bg: "#d1fae5" },
    minor_revision: { label: "Minor Revision", color: "#0284c7", bg: "#e0f2fe" },
    major_revision: { label: "Major Revision", color: "#d97706", bg: "#fef3c7" },
    structural_edit:{ label: "Structural Edit",color: "#ea580c", bg: "#ffedd5" },
    rewrite:        { label: "Rewrite",        color: "#dc2626", bg: "#fee2e2" },
    reject:         { label: "Reject",         color: "#7f1d1d", bg: "#fecaca" },
  };
  const v = verdicts[r.verdict] || {};
  const esc = (x) => String(x||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
  const listItems = (arr, color) =>
    (arr||[]).map((x,i)=>`<li style="color:${color};margin-bottom:6px">${i+1}. ${esc(x)}</li>`).join("");
  const filename = `FEUR-${String(r.title||"").replace(/\s+/g,"-").slice(0,30)}-${new Date().toISOString().slice(0,10)}`;

  const html = `<!DOCTYPE html><html lang="ro"><head><meta charset="UTF-8"><title>${esc(filename)}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Crimson+Pro:ital,wght@0,400;0,600;1,400&family=Inter:wght@400;500;600;700&display=swap');
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Inter',Georgia,serif;color:#1f2937;font-size:13px;line-height:1.6}
  .page{max-width:740px;margin:0 auto;padding:40px 48px}
  @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}.no-print{display:none}.page{padding:20px 32px}}
  .header{background:#1d4ed8;color:#fff;padding:18px 24px;border-radius:10px;margin-bottom:24px}
  .header h1{font-size:17px;font-weight:700;margin-bottom:3px}
  .header p{font-size:11px;opacity:0.7}
  .title{font-family:'Crimson Pro',Georgia,serif;font-size:26px;font-weight:600;margin-bottom:4px}
  .meta{margin-bottom:6px;font-size:13px;color:#6b7280}
  .score-box{border:1px solid #e5e7eb;border-radius:10px;padding:16px 20px;margin:16px 0;display:flex;gap:32px;align-items:flex-start;background:#f9fafb}
  .score-num{font-size:42px;font-weight:700;line-height:1}
  .score-label{font-size:10px;color:#9ca3af;margin-top:2px}
  .verdict-badge{display:inline-block;padding:3px 12px;border-radius:20px;font-size:12px;font-weight:600;margin-top:6px}
  .score-details{flex:1}
  .score-row{display:flex;gap:20px;flex-wrap:wrap;margin-bottom:8px}
  .score-item{font-size:12px;color:#6b7280}
  .score-item strong{color:#374151}
  .summary{font-family:'Crimson Pro',Georgia,serif;font-size:15px;line-height:1.75;color:#374151;margin:20px 0;font-style:italic;padding:16px 20px;background:#f8fafc;border-left:3px solid #1d4ed8;border-radius:0 8px 8px 0}
  .section-title{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#1e40af;background:#eff6ff;padding:6px 12px;border-radius:6px;margin:20px 0 10px}
  .sw-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px}
  .sw-box{padding:12px 14px;border-radius:8px}
  .sw-box.s{background:#f0fdf4;border:1px solid #bbf7d0}
  .sw-box.w{background:#fff7ed;border:1px solid #fed7aa}
  .sw-box h4{font-size:12px;font-weight:600;margin-bottom:6px}
  .rec-list{list-style:none;padding:0}
  .rec-list li{padding:8px 0;border-bottom:1px solid #f3f4f6;font-size:13px;color:#1e3a8a}
  .footer{margin-top:32px;padding-top:16px;border-top:1px solid #e5e7eb;text-align:center;font-size:10px;color:#9ca3af}
  .print-btn{position:fixed;bottom:24px;right:24px;padding:12px 24px;background:#1d4ed8;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer}
</style></head><body>
<div class="page">
  <div class="header"><h1>Raport FEUR · Narratiq EditorialAI România</h1><p>FEUR-1 Architecture Specification v1.0 · ${esc(new Date(r.created_at).toLocaleDateString("ro-RO"))}</p></div>
  <div class="title">${esc(r.title)}</div>
  <div class="meta">${[r.author&&`Autor: ${esc(r.author)}`,`Gen: ${esc(r.genre_label)}`,`Încredere AI: ${r.confidence}%`].filter(Boolean).join(" · ")}</div>
  <div class="score-box">
    <div style="text-align:center;min-width:80px">
      <div class="score-num" style="color:${v.color||'#374151'}">${Math.round(r.feur_score)}</div>
      <div class="score-label">/ 100 · FEUR</div>
      <div class="verdict-badge" style="background:${v.bg||'#f3f4f6'};color:${v.color||'#374151'}">${v.label||""}</div>
    </div>
    <div class="score-details">
      <div class="score-row">
        <div class="score-item">UC <strong>${Math.round(r.uc_score||0)}/50</strong></div>
        <div class="score-item">Gen <strong>${Math.round(r.genre_score||0)}/10</strong></div>
        <div class="score-item">RML <strong>${Math.round(r.rml_score||0)}/100</strong></div>
      </div>
    </div>
  </div>
  ${s.summary?`<div class="summary">${esc(s.summary)}</div>`:""}
  <div class="sw-grid">
    <div class="sw-box s"><h4 style="color:#065f46">✓ Puncte forte</h4><ul>${listItems(s.strengths,"#065f46")}</ul></div>
    <div class="sw-box w"><h4 style="color:#9a3412">⚠ Probleme detectate</h4><ul>${listItems(s.weaknesses,"#9a3412")}</ul></div>
  </div>
  <div class="section-title">Recomandări editoriale FEUR</div>
  <ul class="rec-list">${listItems(s.recommendations,"#1e3a8a")}</ul>
  <div class="footer">Raport generat de Narratiq EditorialAI România · FEUR-1 Architecture Specification v1.0<br>Raport AI. Nu înlocuiește editorul uman.</div>
</div>
<button class="print-btn no-print" onclick="window.print()">⬇ Salvează PDF</button>
<script>document.title="${esc(filename)}";setTimeout(()=>window.print(),600);</script>
</body></html>`;

  const w = window.open("", "_blank");
  if (!w) { alert("Permite ferestrele pop-up pentru a descărca PDF-ul."); return; }
  w.document.write(html);
  w.document.close();
}

const VERDICTS = {
  publish_now:    { color: "#059669", bg: "#d1fae5" },
  minor_revision: { color: "#0284c7", bg: "#e0f2fe" },
  major_revision: { color: "#d97706", bg: "#fef3c7" },
  structural_edit:{ color: "#ea580c", bg: "#ffedd5" },
  rewrite:        { color: "#dc2626", bg: "#fee2e2" },
  reject:         { color: "#7f1d1d", bg: "#fecaca" },
};

export default function Reports() {
  const { getToken } = useAuth();
  const { lang } = useLang();
  const L = lang.reports;
  const [reports, setReports] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [filterVerdict, setFilterVerdict] = useState("");
  const [sort, setSort] = useState("date");
  const [selected, setSelected] = useState(null);

  const fetchReports = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ sort, limit: 50 });
      if (filterVerdict) params.append("verdict", filterVerdict);
      const res = await fetch(`${API}/api/reports?${params}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (res.ok) {
        const data = await res.json();
        setReports(data.reports || []);
        setTotal(data.total || 0);
      }
    } catch {
      // silently fail
    } finally {
      setLoading(false);
    }
  }, [sort, filterVerdict, getToken]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  const handleDelete = async (id) => {
    if (!window.confirm(L.confirmDelete)) return;
    try {
      await fetch(`${API}/api/reports/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      setReports(prev => prev.filter(r => r.id !== id));
      if (selected?.id === id) setSelected(null);
    } catch { }
  };

  const filtered = reports.filter(r =>
    (r.title + (r.author || "")).toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      <Navbar />
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "24px 16px" }}>

        <h1 style={{ fontSize: 20, fontWeight: 700, margin: "0 0 20px", fontFamily: "Georgia, serif" }}>{L.title}</h1>

        {/* Toolbar */}
        <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
          <input value={search} onChange={e => setSearch(e.target.value)}
            placeholder={L.searchPh}
            style={{ flex: 1, minWidth: 180, padding: "8px 12px", border: "0.5px solid #d1d5db", borderRadius: 8, fontSize: 13, fontFamily: "sans-serif" }} />
          <select value={filterVerdict} onChange={e => setFilterVerdict(e.target.value)}
            style={{ padding: "8px 10px", border: "0.5px solid #d1d5db", borderRadius: 8, fontSize: 13, fontFamily: "sans-serif", background: "#fff" }}>
            <option value="">{L.filterVerdict}</option>
            {Object.keys(VERDICTS).map(v => (
              <option key={v} value={v}>{lang.verdicts[v]}</option>
            ))}
          </select>
          <select value={sort} onChange={e => setSort(e.target.value)}
            style={{ padding: "8px 10px", border: "0.5px solid #d1d5db", borderRadius: 8, fontSize: 13, fontFamily: "sans-serif", background: "#fff" }}>
            <option value="date">{L.sortDate}</option>
            <option value="score">{L.sortScore}</option>
            <option value="title">{L.sortTitle}</option>
          </select>
        </div>

        <p style={{ fontSize: 12, color: "#9ca3af", margin: "0 0 12px", fontFamily: "sans-serif" }}>
          {L.count(filtered.length, total)}
        </p>

        {loading && (
          <p style={{ fontSize: 13, color: "#9ca3af", fontFamily: "sans-serif" }}>{lang.common.loading}</p>
        )}

        {!loading && filtered.length === 0 && (
          <div style={{ background: "#fff", border: "0.5px solid #e5e7eb", borderRadius: 10, padding: "32px 20px", textAlign: "center" }}>
            <p style={{ fontSize: 14, color: "#6b7280", margin: 0, fontFamily: "sans-serif" }}>
              {reports.length === 0 ? L.empty : L.emptyFiltered}
            </p>
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {filtered.map(r => {
            const v = VERDICTS[r.verdict] || {};
            return (
              <div key={r.id}
                style={{ background: "#fff", border: `0.5px solid ${selected?.id === r.id ? "#93c5fd" : "#e5e7eb"}`, borderRadius: 10, padding: "14px 16px", cursor: "pointer" }}
                onClick={() => setSelected(selected?.id === r.id ? null : r)}
                onMouseEnter={e => e.currentTarget.style.borderColor = "#93c5fd"}
                onMouseLeave={e => e.currentTarget.style.borderColor = selected?.id === r.id ? "#93c5fd" : "#e5e7eb"}>

                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  <div style={{ width: 48, textAlign: "center", flexShrink: 0 }}>
                    <p style={{ fontSize: 20, fontWeight: 700, color: "#1d4ed8", margin: 0, fontFamily: "sans-serif" }}>{Math.round(r.feur_score)}</p>
                    <p style={{ fontSize: 10, color: "#9ca3af", margin: 0, fontFamily: "sans-serif" }}>FEUR</p>
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 3, flexWrap: "wrap" }}>
                      <span style={{ fontWeight: 600, fontSize: 14, color: "#111827", fontFamily: "sans-serif" }}>{r.title}</span>
                      {r.verdict && (
                        <span style={{ background: v.bg, color: v.color, fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 10, fontFamily: "sans-serif" }}>
                          {lang.verdicts[r.verdict]}
                        </span>
                      )}
                    </div>
                    <p style={{ fontSize: 12, color: "#6b7280", margin: 0, fontFamily: "sans-serif" }}>
                      {r.author || lang.common.unknown} · {r.genre_label} · {new Date(r.created_at).toLocaleDateString("ro-RO")}
                    </p>
                  </div>

                  <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                    <button onClick={e => { e.stopPropagation(); downloadReportPDF(r); }}
                      style={{ padding: "5px 10px", background: "#eff6ff", color: "#1d4ed8", border: "0.5px solid #bfdbfe", borderRadius: 6, fontSize: 12, cursor: "pointer", fontFamily: "sans-serif" }}>
                      PDF
                    </button>
                    <button onClick={e => { e.stopPropagation(); handleDelete(r.id); }}
                      style={{ padding: "5px 10px", background: "#fef2f2", color: "#dc2626", border: "0.5px solid #fecaca", borderRadius: 6, fontSize: 12, cursor: "pointer", fontFamily: "sans-serif" }}>
                      {L.btnDelete}
                    </button>
                  </div>
                </div>

                {selected?.id === r.id && (
                  <div style={{ marginTop: 14, paddingTop: 14, borderTop: "0.5px solid #f3f4f6", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 }}>
                    {[
                      ["UC", r.uc_score, 50],
                      ["Gen", r.genre_score, 10],
                      ["RML", r.rml_score, 100],
                      [L.labelConf, r.confidence, 100],
                    ].map(([lbl, val, mx]) => (
                      <div key={lbl} style={{ textAlign: "center", background: "#f9fafb", borderRadius: 8, padding: "8px 4px" }}>
                        <p style={{ fontSize: 10, color: "#9ca3af", margin: "0 0 2px", fontFamily: "sans-serif" }}>{lbl}</p>
                        <p style={{ fontSize: 16, fontWeight: 700, color: "#374151", margin: 0, fontFamily: "sans-serif" }}>
                          {val != null ? Math.round(val) : "–"}<span style={{ fontSize: 10, color: "#9ca3af" }}>/{mx}</span>
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
